module.exports = __webpack_public_path__ + "static/example_month_weekdays_only-6ddc0914c6d16a820437c448806c8571.png";